export var defaultProps = {
    direction: 'horizontal',
    size: '8',
    unit: 'px',
    wrap: false,
    align: 'Top',
};
